import type {
  AdSizeForecasting,
  DataTypeForecasting,
  SortingKeysForecasting,
  USCityForecasting,
  VideoDurationForecasting,
} from '@openx/types/dealForecasting.ts';
import type { ConstValues } from '@openx/types/helpers.ts';

export type TopMarketRequestsData = {
  entry: string;
  marketRequests: string;
  progress: number;
};

export type TableState = {
  data: DataTypeForecasting[];
  filters: {
    phrase: string;
    sort: {
      dir: number;
      column: SortingKeysForecasting;
    };
  };
  type: UnforecastedTargetingSectionTab;
};

export const UnforecastedTargetingSectionTab = {
  AdSize: 'ad_sizes',
  VideoDuration: 'video_durations',
  USCity: 'us_cities',
} as const;
export type UnforecastedTargetingSectionTab = ConstValues<typeof UnforecastedTargetingSectionTab>;

export const FiltersActionType = {
  Phrase: 'phrase',
  ResetState: 'resetState',
  ChangeSortingDirection: 'changeSortingDirection',
  SortData: 'sortData',
} as const;
export type FiltersActionType = ConstValues<typeof FiltersActionType>;

export type FiltersAction = {
  type?: FiltersActionType;
  phrase?: string;
  tableType?: UnforecastedTargetingSectionTab;
  sortColumn?: SortingKeysForecasting;
  initState?: TableState;
  sortDirection?: SortDirection;
};

export const SortDirection = {
  ASC: 1,
  DESC: -1,
} as const;
export type SortDirection = ConstValues<typeof SortDirection>;

export type UnforecastedTargeting = {
  adSizes: AdSizeForecasting[];
  usCities: USCityForecasting[];
  videoDurations: VideoDurationForecasting[];
};

export type TableColumns = {
  [UnforecastedTargetingSectionTab.AdSize]: (keyof AdSizeForecasting)[];
  [UnforecastedTargetingSectionTab.VideoDuration]: (keyof VideoDurationForecasting)[];
  [UnforecastedTargetingSectionTab.USCity]: (keyof USCityForecasting)[];
};
